var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V39C2 39.7956 2.31607 40.5587 2.87868 41.1213C3.44129 41.6839 4.20435 42 5 42H39C39.7956 42 40.5587 41.6839 41.1213 41.1213C41.6839 40.5587 42 39.7956 42 39V5C42 4.20435 41.6839 3.44129 41.1213 2.87868C40.5587 2.31607 39.7956 2 39 2V2Z",
    stroke: "#8735A5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.0537C13.325 13.0537 17.325 11.0537 22 11.0537C26.675 11.0537 30.675 13.0537 34 17.0537",
    stroke: "#8735A5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 29C22.7956 29 23.5587 28.6839 24.1213 28.1213C24.6839 27.5587 25 26.7956 25 26C25 25.2044 24.6839 24.4413 24.1213 23.8787C23.5587 23.3161 22.7956 23 22 23C21.2044 23 20.4413 23.3161 19.8787 23.8787C19.3161 24.4413 19 25.2044 19 26C19 26.7956 19.3161 27.5587 19.8787 28.1213C20.4413 28.6839 21.2044 29 22 29Z",
    fill: "#8735A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19L22.008 26",
    stroke: "#8735A5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeight);
export default __webpack_public_path__ + "static/media/icon-weight.304a2107ca465fb469e6fd5ffdd5c795.svg";
export { ForwardRef as ReactComponent };